import { useState, useCallback } from 'react';
import { useServices } from 'services';
import UserHistoryEvent from 'types/UserHistoryEvent';

interface UseUserHistoryReturn {
  history: UserHistoryEvent[];
  isLoading: boolean;
  error: string | null;
  fetchHistory: (email: string) => Promise<void>;
}

export default function useUserHistory(): UseUserHistoryReturn {
  const { authService } = useServices();
  const [history, setHistory] = useState<UserHistoryEvent[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistory = useCallback(
    async (email: string): Promise<void> => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await authService.rdmApiService.axios.get(
          `/user-history/${encodeURIComponent(email)}`
        );
        const responseData = response.data;
        const events: UserHistoryEvent[] = Array.isArray(responseData?.items)
          ? responseData.items
          : Array.isArray(responseData)
          ? responseData
          : [];
        // Show newest first.
        events.sort((a, b) => (a.event_key < b.event_key ? 1 : -1));
        setHistory(events);
      } catch (e) {
        console.error('Error fetching user history:', e);
        setError('Failed to load user history.');
        setHistory([]);
      } finally {
        setIsLoading(false);
      }
    },
    [authService]
  );

  return { history, isLoading, error, fetchHistory };
}